import React from 'react'
import { Icon, Image, List, Segment } from 'semantic-ui-react'
import { uniqueKey } from '../../common/keys'
import { gEnums } from '../../enums/globalEnums'

const ImageList = ({ listItems, selectedItem, _imageProps, parentItems, noSize, storageType, oc }) => {

  const _imageSize = _imageProps?.appUser?.imageSize ? _imageProps.appUser.imageSize : 'small'

  const getSource = (f) => {
    try {
      const src = URL.createObjectURL(f)
      return src
    } catch (error) {
      return f
    }
  }

  const result = parentItems ? _.filter(parentItems, (obj) => _.has(obj, 'fileImage')) : null;

  const image = (keyy, src) => <Image key={keyy} size={noSize ? null : _imageSize} src={src} alt={'imageEdit'}></Image>

  const folderList = () => {
    const items = listItems ? listItems.map((item, index) => {
      const { name, fileImage } = item
      let fileContent;
      switch (storageType) {
        case gEnums.storageTypes.pdf:
          fileContent = <Icon name='file pdf outline' size='huge' />
          break
        default:
          fileContent = fileImage && image(uniqueKey('fli', index), getSource(fileImage))
      }

      const result_match = result ? _.find(result, (obj) => obj?.name === name) : null;

      return <List.Item key={uniqueKey('fl', index)} onClick={() => { selectedItem && oc(item) }} className={result_match ? 'sel' : null}>
        {fileContent}
        <List.Content>
          <List.Header>{name}</List.Header>
          {result_match && <List.Description>{result_match.name}</List.Description>}
        </List.Content>
      </List.Item>
    }) : []
    return <Segment basic><List className={'image-list-list'} divided relaxed >{items}</List></Segment>
  }

  return folderList()

}

export default ImageList